import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/util/services/auth.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/util/modal/modal.component';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CustomValidators } from 'src/app/shared/validators/repeat-password';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/util/services/notification.service';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  formUser: FormGroup;
  isSuccessful = false;
  isSignUpFailed = false;
  errorMessage = '';
  thisControl: FormControl;
  otherControl: FormControl;
  errorPassword = false;
  sameUser = false;
  checked = true;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private matDialog: MatDialog,
    private router: Router,
    private notificationService: NotificationService,
    private translate: TranslateService
    ) { }

  ngOnInit() {
    this.createFormInputs();
  }

  createFormInputs() {
    this.formUser = this.formBuilder.group(
      {
        username          : new FormControl('', [Validators.required, Validators.minLength(4)]),
        name 			        : new FormControl('', [Validators.required]),
        surname 			    : new FormControl('', [Validators.required]),
        email 			      : new FormControl('', [Validators.required, Validators.email]),
        phoneNumber		    : new FormControl('', [Validators.required]),
        password 		      : new FormControl('', [Validators.required, Validators.minLength(8)]),
        repeatPassword    : new FormControl('', Validators.required),
        checked           : new FormControl(false)
      });
  }

  get getChecked(): boolean {
    return this.formUser.get('checked').value;
  }

  checkPassword(){
    const password = this.formUser.get('password').value;
    const repeatPassword = this.formUser.get('repeatPassword');

    if (password===repeatPassword.value) {
      this.errorPassword = false;
    }else{
      repeatPassword.reset();
      this.errorPassword = true;
    }
  }
 

 onSubmit() {
   this.isSuccessful = false;
   
   this.checked = this.getChecked;
   if (this.formUser.valid && !this.errorPassword && this.formUser.get('checked').value) {
     console.log(this.formUser.value);
    this.authService.register(this.formUser.value).subscribe(
      data => {
        this.isSuccessful = false;
        this.router.navigate(['/auth/signin']);
        setTimeout(() => { this.router.navigate(['/auth/signin']); }, 4000);
        this.isSignUpFailed = false;
        //TODO cambiar por modal
        this.notificationService.showSuccess(this.translate.instant('SUCCESS_REGISTER_USER'), 5);
      },
      err => {
        this.notificationService.showError(this.translate.instant('ERROR_REGISTER_USER'), 5);
        if(err.status==400){
          this.sameUser= true;
        }else{
          this.isSignUpFailed = true;
        }
        this.errorMessage = err.error.message;
      }
    );
   } else {
     console.log('Errores en el formulario');
   }
 }

 openDialog() {
  const dialogConfig = new MatDialogConfig();
  this.matDialog.open(ModalComponent, dialogConfig);
  
  }

  readConditions() {
    const winRef = window.open('/politica-privacidad');
  }
}
